<!--<mat-card class="list-card">-->
<!--    <mat-card-header>-->
<!--        <h3 mat-card-title>-->
<!--            Vorlagen-->
<!--            <fa-icon icon="info-circle" [matTooltip]="Data.ListView ? 'Hier bearbeiten Sie Ihre Vorlagen für die Abrechnungspositionen' : 'Hier bearbeiten Sie Ihre Abrechnungspositionen und nicht die Vorlagen'" size="lg"> </fa-icon>-->
<!--        </h3>-->

<!--        <mat-form-field>-->
<!--            <app-select-search [placeholder]="'Vorlagentyp'" [formControl]="ArlTypeForm" [Options]="TemplateTypes$ | async" [CompareOptions]="CompareByIdAndType"></app-select-search>-->
<!--        </mat-form-field>-->
<!--        <div>-->
<!--            <mat-form-field floatLabel="never" color="accent" *ngIf="ShowSearchBar$ | async" [ngStyle]="{ width: (IsSmallWidth$ | async) ? '100%' : '50%' }" style="margin-right: 0.5rem">-->
<!--                <mat-label>Suche</mat-label>-->
<!--                <input type="text" [formControl]="SearchForm" matInput #input />-->
<!--            </mat-form-field>-->
<!--            <button-->
<!--                app-round-button-->
<!--                [Inverted]="Data.ListView"-->
<!--                matTooltipPosition="left"-->
<!--                [matTooltip]="(ShowSearchBar$ | async) ? 'Ausblenden' : 'Suche'"-->
<!--                (click)="ShowSearchBar$.next(!this.ShowSearchBar$.value)"-->
<!--                style="margin-right: 0.5rem"-->
<!--            >-->
<!--                <fa-icon [icon]="(ShowSearchBar$ | async) ? 'times' : 'search'"></fa-icon>-->
<!--            </button>-->
<!--            <button style="margin-right: 0.5rem" app-round-button (click)="EditMode.next(!EditMode.value)" [matTooltip]="Data.ListView ? 'Bearbeiten' : 'Vorlage bearbeiten'" [Inverted]="EditMode | async" *ngIf="SelectedTemplateId$ | async">-->
<!--                <fa-icon icon="pencil-alt"></fa-icon>-->
<!--            </button>-->
<!--            <button-->
<!--                style="margin-right: 0.5rem"-->
<!--                app-round-button-->
<!--                (click)="Multiselect.next(!Multiselect.value)"-->
<!--                [matTooltip]="!Data.ListView && (Multiselect | async) ? 'Aktiv' : 'Mehrfachauswahl'"-->
<!--                [Inverted]="Multiselect | async"-->
<!--                *ngIf="!(EditMode | async) && !Data.ListView"-->
<!--            >-->
<!--                <fa-icon icon="check-square"></fa-icon>-->
<!--            </button>-->
<!--            <button [style]="(ShowSearchBar$ | async) && !(SelectedTemplateId$ | async) ? 'margin-right: -2.5rem' : 'margin-right: .5rem'" app-round-button (click)="OpenModifyTemplateDialog(null, true)" matTooltip="Vorlage hinzufügen">-->
<!--                <fa-icon icon="plus"></fa-icon>-->
<!--            </button>-->
<!--        </div>-->
<!--    </mat-card-header>-->
<!--    <div>-->
<!--        <ngx-simplebar class="clickable-list-container">-->
<!--            <app-arl-template-table-->
<!--                [multiselect]="Multiselect | async"-->
<!--                [filterQuery]="SearchForm.value"-->
<!--                [filterCommissionType]="ArlTypeForm.value?.type === templateFilterTypes.commissionType ? ArlTypeForm.value.id : null"-->
<!--                [filterARLTemplateType]="ArlTypeForm.value?.type === templateFilterTypes.arlTemplateType ? ArlTypeForm.value.id : null"-->
<!--                [filterNoCommissionTypeAndNoArlTemplateType]="ArlTypeForm.value?.type === templateFilterTypes.none"-->
<!--                [disabledForMultiselect]="Data.addedTemplateIds || []"-->
<!--                [(selectedArlTemplates)]="SelectedTemplates"-->
<!--            ></app-arl-template-table>-->

<!--        </ngx-simplebar>-->
<!--    </div>-->
<!--    <button app-button style="margin: 0.5rem auto -0.5rem 0.5rem" *ngIf="Multiselect | async" [IsLoading]="LS.IsLoading$ | async" (click)="MultipleSave$.next()" [Disabled]="!SelectedTemplates.length">hinzufügen</button>-->
<!--</mat-card>-->

<div class="header">
    <h3 mat-dialog-title >
        Vorlagen
        <fa-icon icon="info-circle" [matTooltip]="Data.ListView ? 'Hier bearbeiten Sie Ihre Vorlagen für die Abrechnungspositionen' : 'Hier bearbeiten Sie Ihre Abrechnungspositionen und nicht die Vorlagen'" size="lg"> </fa-icon>
    </h3>

        <mat-form-field class='header-vorlagentyp'>
            <app-select-search [placeholder]="'Vorlagentyp'" [formControl]="ArlTypeForm" [Options]="TemplateTypes$ | async" [CompareOptions]="CompareByIdAndType"></app-select-search>
        </mat-form-field>
        <div class="header-buttons">
            <mat-form-field floatLabel="never" color="accent" *ngIf="ShowSearchBar$ | async"  style="margin-right: 0.5rem">
                <mat-label>Suche</mat-label>
                <input type="text" [formControl]="SearchForm" matInput #input />
            </mat-form-field>
            <button
                app-round-button
                [Inverted]="Data.ListView"
                matTooltipPosition="left"
                [matTooltip]="(ShowSearchBar$ | async) ? 'Ausblenden' : 'Suche'"
                (click)="ShowSearchBar$.next(!this.ShowSearchBar$.value)"
                style="margin-right: 0.5rem"
            >
                <fa-icon [icon]="(ShowSearchBar$ | async) ? 'times' : 'search'"></fa-icon>
            </button>
            <button
                *ngIf="Data?.newOptionDefaultValues?.LedgerImportId !== null"
                style="margin-right: 0.5rem;"
                app-round-button
                (click)="OpenLedgerImportList()"
                [matTooltip]="'Positionen aus anderen Dokumenten übernehmen'"
            >
                <app-double-icon [Icon]="'file-invoice'" Icon2="plus"></app-double-icon>
            </button>
            <button style="margin-right: 0.5rem" app-round-button (click)="EditMode.next(!EditMode.value)"
                [matTooltip]="Data.ListView ? 'Bearbeiten' : 'Vorlage bearbeiten'"
                [Inverted]="EditMode | async"
                *ngIf="SelectedTemplateId$ | async"
            >
                <fa-icon icon="pencil-alt"></fa-icon>
            </button>
            <button
                style="margin-right: 0.5rem"
                app-round-button
                (click)="Multiselect.next(!Multiselect.value)"
                [matTooltip]="!Data.ListView && (Multiselect | async) ? 'Aktiv' : 'Mehrfachauswahl'"
                [Inverted]="Multiselect | async"
                *ngIf="!(EditMode | async) && !Data.ListView && !Data.onlyOne"
            >
                <fa-icon icon="check-square"></fa-icon>
            </button>
            <button
                app-round-button
                (click)="OpenModifyTemplateDialog(null, true)"
                matTooltip="Vorlage hinzufügen"
                style="margin-right: 0.5rem"
            >
                <fa-icon icon="plus"></fa-icon>
            </button>
        </div>

</div>
<app-arl-template-table matDialogContent
    [multiselect]="Multiselect | async"
    [filterQuery]="SearchForm.value"
    [filterCommissionType]="ArlTypeForm.value?.type === templateFilterTypes.commissionType ? ArlTypeForm.value.id : null"
    [filterARLTemplateType]="ArlTypeForm.value?.type === templateFilterTypes.arlTemplateType ? ArlTypeForm.value.id : null"
    [filterNoCommissionTypeAndNoArlTemplateType]="ArlTypeForm.value?.type === templateFilterTypes.none"
    [disabledForMultiselect]="Data.addedTemplateIds || []"
    [(selectedArlTemplates)]="SelectedTemplates"
    [multiple]="!Data.onlyOne"
    [FilterMaterialsByCustomerId]="Data.filterMaterialsByCustomerId"
    [isOrder]="Data.isOrder"
    [isOffer]="Data.isOffer"
></app-arl-template-table>
<mat-dialog-actions>
    <button app-button style="margin: 0.5rem auto -0.5rem 0.5rem" *ngIf="Multiselect | async" [IsLoading]="LS.IsLoading$ | async" (click)="MultipleSave$.next()" [Disabled]="!SelectedTemplates.length">hinzufügen</button>
</mat-dialog-actions>
